// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"919":"todo","1377":"chat","5514":"kanban","6008":"editor","8018":"create_catalog_dialog","8024":"companies"}[chunkId] || chunkId) + "." + {"919":"6cb9c71d","1377":"69810680","5514":"145f28e1","6008":"5a6583b8","8018":"b258e9e2","8024":"699724d6","8510":"3582bacd","9565":"83006cd6"}[chunkId] + ".chunk.css";
};